"use client";

import { useEffect } from "react";

const VideoConsoleLogger = () => {
    useEffect(() => {
        const loggedUrls = new Set();

        const normaliseUrl = (url) => {
            if (!url) return "";

            try {
                return new URL(url, window.location.href).href;
            } catch {
                return url;
            }
        };

        const isYouTubeUrl = (url) =>
            /youtube\.com|youtu\.be|youtube-nocookie\.com/i.test(url || "");

        const logMedia = () => {
            const mediaList = [];

            // HTML5 videos
            document.querySelectorAll("video").forEach((video, index) => {
                const sourceUrls = Array.from(
                    video.querySelectorAll("source"),
                )
                    .map(
                        (source) =>
                            source.src ||
                            source.getAttribute("src") ||
                            source.getAttribute("data-src"),
                    )
                    .filter(Boolean);

                const src = normaliseUrl(
                    video.currentSrc ||
                        video.src ||
                        video.getAttribute("src") ||
                        video.getAttribute("data-src") ||
                        sourceUrls[0],
                );

                if (src) {
                    loggedUrls.add(src);
                }

                mediaList.push({
                    type: "HTML5 Video",
                    number: index + 1,
                    url: src || "No URL found",
                    poster: video.poster || "",
                });
            });

            // YouTube/Vimeo popup iframes
            document.querySelectorAll("iframe").forEach((iframe, index) => {
                const src = normaliseUrl(
                    iframe.src ||
                        iframe.getAttribute("src") ||
                        iframe.getAttribute("data-src") ||
                        iframe.getAttribute("data-url"),
                );

                if (!src) return;

                const isVideoIframe =
                    isYouTubeUrl(src) ||
                    /vimeo\.com|player\.vimeo\.com/i.test(src);

                if (!isVideoIframe) return;

                loggedUrls.add(src);

                mediaList.push({
                    type: isYouTubeUrl(src)
                        ? "YouTube iframe"
                        : "Vimeo iframe",
                    number: index + 1,
                    url: src,
                    title: iframe.title || "",
                });
            });

            window.allPageVideos = [...loggedUrls];
        };

        // Detect popup iframe insertion and src changes.
        // The callback runs after every DOM change on the page (menus, sliders),
        // inside the same frame as the user's tap, so keep it O(1): just
        // debounce a rescan instead of inspecting each mutation (INP).
        let rescanTimer;
        const observer = new MutationObserver(() => {
            clearTimeout(rescanTimer);
            rescanTimer = setTimeout(logMedia, 500);
        });

        // Initial scan + observe once the browser is idle, not during hydration
        const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
        const cancelIdle = window.cancelIdleCallback || clearTimeout;
        const idleHandle = idle(() => {
            logMedia();
            observer.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ["src", "data-src", "data-url"],
            });
        });

        return () => {
            cancelIdle(idleHandle);
            clearTimeout(rescanTimer);
            observer.disconnect();
            delete window.allPageVideos;
        };
    }, []);

    return null;
};

export default VideoConsoleLogger;